import {
  MODELS_HELPER_TEXT,
  MODELS_PREFIX,
  openAiModelsFetch,
  withAllowedModelsHint,
} from "../models";
import { openaiUsage } from "../openai/usage";
import { OPENAI_COMPATIBLE_USAGE_HINT } from "../openai/usageHint";
import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const DEFAULT_DEEPSEEK_BASE_URL = "https://api.deepseek.com/v1";

const MODELS_ENDPOINT = `${DEFAULT_DEEPSEEK_BASE_URL}/models`;

const deepseekModelsFetch = openAiModelsFetch(
  "Fetch models from DeepSeek",
  () => MODELS_ENDPOINT
);

export const deepseek = defineConnector({
  identifier: "deepseek",
  name: "DeepSeek",
  tagLine: "AI models and reasoning",
  logo,
  protocol: "http",
  tags: ["ai", "engineering"],
  defaultUrlPattern: () => "https://api\\.deepseek\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit the [DeepSeek Platform](https://platform.deepseek.com/api_keys) and create a new API key.",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "DeepSeek API key",
          placeholder: "sk-...",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
    {
      title: "Choose available models (optional)",
      items: [
        {
          kind: "list",
          label: "Available models",
          prefix: MODELS_PREFIX,
          columns: [{ field: "name", placeholder: "deepseek-chat" }],
          addLabel: "Add model",
          fetch: deepseekModelsFetch,
          helperText: MODELS_HELPER_TEXT,
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => MODELS_ENDPOINT,
  },
  usageHint: (configuration) =>
    withAllowedModelsHint(OPENAI_COMPATIBLE_USAGE_HINT, configuration),
  usage: openaiUsage(),
});
